import {BASE_TRACK_API_URL} from '@constants/config'
import {apiRequestWithAuth} from '@helpers/query/apiRequestWithAuth'
import {OnShowError} from '@baseTypes/base'
import {serialize} from '@helpers/query/serialize'
import moment from 'moment-timezone'
import {DATE_FORMAT_CAMERAS} from '@containers/cameras/constants/dateFormat'
import {IAccountCameraRecording, IDeviceRecordingFile, IRecordingUrl} from '@containers/monitoringPlatform/geoZones/types'

const BASE_URL_ACCOUNTS = `${BASE_TRACK_API_URL}/v1/accounts`

export const getRecordingsUploadedListApi = async (
	accountId: number,
	inGeozoneOnly: boolean,
	singleVoyage: boolean,
	onError?: OnShowError
): Promise<IAccountCameraRecording[]> => {
	const params = new URLSearchParams()
	if (inGeozoneOnly) {
		params.set('inGeozoneOnly', 'true')
	}
	if (singleVoyage) {
		params.set('singleVoyage', 'true')
	}
	const query = params.toString()
	const url = `${BASE_URL_ACCOUNTS}/${accountId}/recordings/uploaded${query ? `?${query}` : ''}`
	return await apiRequestWithAuth<IAccountCameraRecording[]>({
		url,
		options: {
			method: 'GET',
		},
		onError
	})
}

export const getDeviceRecordingsByPeriodApi = async (
	{accountId, deviceId, dateFrom, dateTo, singleVoyage}: {
		accountId: number
		deviceId: number
		dateFrom: string
		dateTo: string
		singleVoyage?: boolean
	},
	onError?: OnShowError
): Promise<IDeviceRecordingFile[]> => {
	const url = `${BASE_URL_ACCOUNTS}/${accountId}/devices/${deviceId}/recordings?` + serialize({
		dateFrom: moment.tz(moment(dateFrom, DATE_FORMAT_CAMERAS).format(), moment.tz.guess()).format(),
		dateTo: moment.tz(moment(dateTo, DATE_FORMAT_CAMERAS).format(), moment.tz.guess()).format(),
		...(singleVoyage ? {singleVoyage: true} : {}),
	})
	return await apiRequestWithAuth<IDeviceRecordingFile[]>({
		url,
		options: {
			method: 'GET',
		},
		onError
	})
}

export const getRecordingUrlApi = async (
	{accountId, recordingId}: {
		accountId: number
		recordingId: number
	},
	onError?: OnShowError
): Promise<IRecordingUrl> => {
	const url = `${BASE_URL_ACCOUNTS}/${accountId}/recordings/${recordingId}/url`
	return await apiRequestWithAuth<IRecordingUrl>({
		url,
		options: {
			method: 'GET',
		},
		onError
	})
}
